import axiosInstance from "../../services/axiosInstance";

interface TakeProductsProps {
  productType?: string;
  showHome?: boolean;
  pageNum: number;
  pageSize: number;
}

export const takeProducts = async (props: TakeProductsProps) => {
  const response = await axiosInstance.get<ApiResponse<HomePageResponse>>(
    "/products/take",
    {
      params: {
        ...props,
      },
    }
  );
  return response.data.result;
};
